import axiosIns from "@/api/axios"

export const GET_CLIENT = (args) => {
    return axiosIns.get(`/role-management/clients`,args);
};
export const GET_CLIENT_ROLES = (clientId,args) => {
    return axiosIns.get(`/role-management/client-roles/${clientId}/roles`, { params: args });
};

export const CREATE_CLIENT_ROLE = (clientId,args) => {
    return axiosIns.post(`/role-management/client-roles/${clientId}/roles`, args);
};
export const DEL_CLIENT_ROLE = (clientId, roleName) => {
    return axiosIns.delete(`/role-management/client-roles/${clientId}/roles/${roleName}`);
};
export const ADD_SITE = (args) => {
    return axiosIns.post(`/dms-portal/site`, args);
};

export const UPDATE_SITE = (args) => {
    return axiosIns.put(`/dms-portal/site?id=${args.id}`, args)
}


export const DEL_SITE = (id) => {
    return axiosIns.delete(`/dms-portal/site?id=${id}`)
}
export const GET_DEPARTMENT = (args) => {
    return axiosIns.get(`dms-portal/site-mapping?${args}`);
};

export const ADD_DEPARTMENT = (args) => {
    return axiosIns.post(`dms-portal/site-mapping`, args);
};

export const UPDATE_DEPARTMENT = (args) => {
    return axiosIns.put(`dms-portal/site-mapping?id=${args.id}`, args)
}

export const DEL_DEPARTMENT = (id) => {
    return axiosIns.delete(`dms-portal/site-mapping?id=${id}`)
}